// extracted by mini-css-extract-plugin
export default {"Quality_quality":"Quality_Quality_quality__z1kmC","Quality_comingSoon":"Quality_Quality_comingSoon__82MkX"};